

<div id="">
   <header id="banner" role="banner">
      <nav class="site-breadcrumbs" id="breadcrumbs">
         <!--<h1> <span>Elementi Navigazione</span> </h1>--> 
         <ul class="breadcrumbs breadcrumbs-horizontal lfr-component">
            <li class="first"><span><a routerLink="">SIRA</a></span></li>
            <li><span><a href="/sirang/iosono">IO SONO</a></span></li>
            <li class="last"><span><a href="/sirang/delegato">Delegato</a></span></li>
         </ul>
      </nav>
   </header>
   <div id="content">
      <div class="portlet-boundary portlet-boundary_103_ portlet-static portlet-static-end " id="p_p_id_103_">
         <span id="p_103"></span> 
         <div class="portlet-body"> </div>
      </div>
      <div class="columns-1" id="main-content" role="main">
         <div class="portlet-layout">
            <div class="portlet-column portlet-column-only" id="column-1">
               <div class="portlet-dropzone portlet-column-content portlet-column-content-only" id="layout-column_column-1">
                  <div class="portlet-boundary portlet-boundary_56_ portlet-journal-content  portlet-draggable" id="p_p_id_56_INSTANCE_tv09RjF8l1dp_">
                     <span id="p_56_INSTANCE_tv09RjF8l1dp"></span> 
                     <div class="portlet-body">
                        <section class="portlet" id="portlet_56_INSTANCE_tv09RjF8l1dp">
                           <table style="width: 100%;">
                              <tbody>
                                 <tr>
                                    
                                    <td>
                                       <header class="portlet-topper gradient">
                                          <h1 class="portlet-title"> <span class="portlet-title-text portlet-title-editable" style="margin-left: 0px;">Servizi online per il delegato</span> </h1>
                                       </header>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                           <div class="portlet-content">
                              <div class=" portlet-content-container" style="">
                                 <div class="portlet-body">
                                    <div class="journal-content-article">
                                       <p> <span style="font-size:14px;">Nel caso in cui un cittadino o un'impresa intendano avvalersi di un intermediario per la presentazione delle istanze può essere attivato il processo di delega.</span></p>
                                       <p> <span style="font-size:14px;">Il delegato potrà, pertanto,</span><span style="font-size: 14px;">&nbsp;presentare una nuova istanza per uno specifico procedimento e/o seguire lo stato di avanzamento delle pratiche già presentate sul Modulo GPA per conto dell'impresa o del cittadino. Potrà accedere ai dataset&nbsp;</span><span style="font-size: 14px;">di Contesto Ambientale pubblici, avendo in tal modo a disposizione un bagaglio di conoscenza che avrà come effetto principale quello di semplificare i procedimenti, riducendo la tempistica attraverso la dematerializzazione e l'ottimizzazione delle funzioni digitale del sistema. La presenza di un modulo cartografico avanzato gli consentirà, inoltre, di sapere, già in fase di individuazione del procedimento da attivare, se nell'area di intervento insistono dei vincoli ambientali. Il delegato verrà, pertanto, guidato nell'attivazione delle procedure necessarie al fine di predisporre l'istanza di interesse.</span></p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </section>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <form action="#" id="hrefFm" method="post" name="hrefFm"> <span></span> </form>
   </div>
</div>